import React, { useState } from 'react';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import VideoVisitTips from "../../dashboard/appointment/VideoVisitTips";

export default function VideoVisitToolTip({ isTwilioVideo }) {
    const [showModal, setShowModal] = useState(false);
    function toggleModal() {
        let activityCodeForModal = "MBHWeb.UI.Twilio.VideoVisitToolTips.Open";
        if (showModal) {
            activityCodeForModal = "MBHWeb.UI.Twilio.VideoVisitToolTips.Close";
        }        
        logUI(activityCodeForModal, new Date(), Tools.getURLPath());
        setShowModal(prevState => !prevState);
    }
    return (
        <div className="row video-visit-tooltip-container">
            <div className="col-12">
                <div className="tips-banner-container">
                    <div className="details-icon-prepend">
                        <div className="icon-col">
                            <div className="svg-tips" />
                        </div>
                        <div className="details-col">
                            <div className="tips-text">Be ready! See our helpful tips for a more successful Video Visit.</div>
                            <button className="btn text-btn" onClick={toggleModal}>VIEW TIPS</button>
                        </div>
                    </div>
                </div>
            </div>
            {showModal && <VideoVisitTips showVideoVisitTipsModal={showModal} toggleVideoVisitTipsModal={toggleModal} isTwilioVideo={isTwilioVideo} />}
        </div>
    );
}
